import { UserbotCatalog } from "../../interfaces"

/** Catalog root unions use a synthetic `value` field, not a DTO wrapper. */
export const isRootUnion = (specs: UserbotCatalog.FieldSpec[]) =>
  specs.length === 1 && specs[0].key === "value" && specs[0].type === "oneOf"

/** Structural hints only: guarded schemas still require server validation. */
export const matchingVariant = (
  variants: UserbotCatalog.FieldSpec[],
  value: unknown,
): UserbotCatalog.FieldSpec | undefined => {
  const candidates = variants.filter((spec) => {
    if (spec.type === "object")
      return (
        !!value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        (spec.fields ?? []).every(
          (f) => !f.required || f.key in (value as object),
        )
      )
    if (spec.type === "array") return Array.isArray(value)
    if (spec.type === "number") return typeof value === "number"
    if (spec.type === "boolean") return typeof value === "boolean"
    if (spec.type === "json") return true
    return typeof value === "string"
  })
  // Prefer the most specific object shape, never drop unmatched fields to guess.
  return candidates.sort(
    (a, b) => (b.fields?.length ?? 0) - (a.fields?.length ?? 0),
  )[0]
}
